import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";

function SubCategoryList() {
  const [subCategoryList, setSubCategoryList] = useState([]);
  const token = sessionStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_APIURL;

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch the list of all sub-categories
  const fetchSubCategoryList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }
    try {
      const response = await axios.get(
        `${baseUrl}api/sub-category/list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Sort data to show newest first, based on the nested category's creation date or the sub-category's own date if available
      const sortedData = (response?.data?.data || []).sort(
        (a, b) => new Date(b.createdAt || b.category.CreatedAt) - new Date(a.createdAt || a.category.CreatedAt)
      );
      setSubCategoryList(sortedData);
    } catch (error) {
      toast.error(
        "Error fetching sub-category data: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  useEffect(() => {
    if (token) {
      fetchSubCategoryList();
    }
  }, [token]);

  const handleDeleteSubCategory = async () => {
    if (!token || !deleteId) {
      toast.error("No token provided or invalid ID!");
      setShowModal(false);
      return;
    }
    try {
      const response = await fetch(
        `${baseUrl}api/sub-category/delete/${deleteId}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.ok) {
        toast.success("Sub-category deleted successfully!");
        fetchSubCategoryList(); // Refresh the list
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete sub-category");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }
    setShowModal(false);
    setDeleteId(null);
  };

  // Updated filter logic for the new data structure
  const filteredData = subCategoryList.filter((item) =>
    (item.name?.toLowerCase() || "").includes(search.toLowerCase()) ||
    (item.category?.catagoryname?.toLowerCase() || "").includes(search.toLowerCase())
  );

  const offset = currentPage * itemsPerPage;
  const paginatedData =
    itemsPerPage === -1
      ? filteredData
      : filteredData.slice(offset, offset + itemsPerPage);
  const pageCount =
    itemsPerPage === -1 ? 1 : Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Sub-Category List</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item active">Sub-Category List</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="card">
            <div className="card-body">
              <div className="datatable-top d-flex justify-content-between align-items-center pt-4">
                <div className="datatable-dropdown">
                  <label>
                    Show{" "}
                    <select
                      className="datatable-selector"
                      value={itemsPerPage}
                      onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setCurrentPage(0);
                      }}
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="-1">All</option>
                    </select>{" "}
                    entries
                  </label>
                </div>
                <div className="datatable-search">
                  <input
                    className="form-control"
                    placeholder="Search..."
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              <div className="datatable-container table-responsive">
                <table className="table table-bordered table-striped datatable">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Sub-Category Name</th>
                      <th scope="col">Parent Category</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((item, index) => (
                        <tr key={item._id}>
                          <td>{offset + index + 1}</td>
                          <td>{item.name}</td>
                          {/* Access nested category name */}
                          <td>{item.category?.catagoryname || "N/A"}</td>
                          <td>
                            <div className="d-flex gap-3">
                              <Link to={`/sub-category/edit/${item._id}`} title="Edit">
                                <i className="bi bi-pencil-square text-primary"></i>
                              </Link>
                              <Link
                                to="#"
                                title="Delete"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeleteId(item._id);
                                  setShowModal(true);
                                }}
                              >
                                <i className="bi bi-trash text-danger"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No matching records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="datatable-bottom d-flex justify-content-between align-items-center">
                <span className="datatable-info">
                  Showing {offset + 1} to {offset + paginatedData.length} of{" "}
                  {filteredData.length} entries
                </span>
                <ReactPaginate
                  previousLabel={"‹"}
                  nextLabel={"›"}
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setCurrentPage(e.selected)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this sub-category?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteSubCategory}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SubCategoryList;
